<template>
  <div class="copy-div">
    <span class="tooltip" :ref="`${element_id}_copied`">Copied</span>
    <span class="tooltip" :ref="`${element_id}_copy`">Copy</span>
    <v-icon
      v-bind="attrs"
      v-on="on"
      color="primary"
      v-on:mouseover="hoverIn(`${element_id}`)"
      v-on:mouseleave="hoverOut(`${element_id}`)"
      @click="copy(`${element_id}`)"
      class="copy-icon"
      >content_copy</v-icon
    >
  </div>
</template>
<script>
import { CopyToClipboardMixin } from "@/mixins/copyToClipboard";

export default {
  props: { element_id: String },
  methods: {
    hoverIn(element_id) {
      this.$refs[`${element_id}_copy`].style.display = "block";
    },
    hoverOut(element_id) {
      this.$refs[`${element_id}_copy`].style.display = "none";
    },
    copy(element_id) {
      CopyToClipboardMixin.methods.copyToClipboard(`#${element_id}`);

      this.$refs[`${element_id}_copied`].style.display = "block";

      this.$refs[`${element_id}_copy`].style.display = "none";

      setTimeout(() => (this.$refs[`${element_id}_copied`].style.display = "none"), 1000);
    }
  }
};
</script>
